// extracted by mini-css-extract-plugin
export var whiteBody = "seo-module--white-body--3mcsb";